var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{attrs:{"value":_vm.value,"header":"Resync"},on:{"closePopup":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }